import { ALL_ACCESS_PROFILE_ROLE, ProfileRoleTypes, TABLET_ONLY_PROFILE_ROLE, CRICKET_BOWLING_COACH_PROFILE_ROLE, READ_ONLY_CORE_LIBRARY_PROFILE_ROLE, TEAM_COACH_PROFILE_ROLE, COACH_PROFILE_ROLE, COACH_ADMIN_PROFILE_ROLE, } from '@strength/db-schema';
import { z } from 'zod';
import { zOneRepMaxFormula } from '../benchmarks';
export { ALL_ACCESS_PROFILE_ROLE, TABLET_ONLY_PROFILE_ROLE, CRICKET_BOWLING_COACH_PROFILE_ROLE, READ_ONLY_CORE_LIBRARY_PROFILE_ROLE, TEAM_COACH_PROFILE_ROLE, COACH_PROFILE_ROLE, COACH_ADMIN_PROFILE_ROLE, };
/** Server-side error message when a role doesn't have permission to access a route. */
export const SERVER_ROLE_PERMISSION_ERROR = 'Insufficient permissions for this route';
// Error when a role is team scoped, but the request is missing the team id(s) to validate
export const TEAM_ID_MISSING_ERROR = 'teamId or teamIds is required';
/**
 * Server-side error when an action would conflict with a bowling workout
 * already scheduled on the same date in another (non-current) block for one of
 * the rostered athletes.
 */
export const CROSS_BLOCK_BOWLING_CONFLICT_ERROR = 'Conflicts with bowling workouts scheduled in another block';
/** Client-side error thrown to trigger error boundary for permission errors. */
export const CLIENT_ROUTE_PERMISSION_ERROR = 'Route not permitted';
export const zProfileRoleType = z.enum(ProfileRoleTypes);
export const OrgSettingsModule = 'OrgSettings';
const module = z.literal(OrgSettingsModule);
export const BaseOrgSettingsSchema = z.object({
    id: z.uuid(),
    orgId: z.uuid(),
    oneRepMaxFormula: zOneRepMaxFormula,
});
export const OrgSettingsFormSchema = BaseOrgSettingsSchema.omit({
    id: true,
});
export const EditOrgSettings = z.object({
    module,
    type: z.literal('EditOrgSettings'),
    input: BaseOrgSettingsSchema,
});
//# sourceMappingURL=commands.js.map